import { useEffect, useRef, useState } from 'react';

/* Flashes an element once, the first time it scrolls into view, when `highlight` is set.
   Pair the returned className with the `.message-flash` animation in index.css. */
export default function useFlashOnView<T extends HTMLElement>(highlight: boolean) {
  const ref = useRef<T>(null);
  const [flashing, setFlashing] = useState(false);

  useEffect(() => {
    const element = ref.current;
    if (!highlight || !element || typeof IntersectionObserver === 'undefined') {
      return;
    }

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setFlashing(true);
          observer.disconnect();
        }
      },
      { threshold: 0.6 }
    );
    observer.observe(element);

    return () => observer.disconnect();
  }, [highlight]);

  return { ref, flashClassName: flashing ? 'message-flash' : '' };
}

/* Chat messages have no id; the sender and timestamp identify one. */
export const messageKey = (message: { senderId: number; createdAt: string }) => `${message.senderId}-${message.createdAt}`;
